'use client';

import { useState } from 'react';
import moment from 'moment';
import useFetch from 'use-http';

import { Button } from '@/components/ui/button';
import { CardHeader } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Heading } from '@/components/ui/shared/heading';

import addToAppleWallet from '@/assets/favicons/LT_Add_to_Apple_Wallet_RGB.svg';
import addToGoogleWallet from '@/assets/favicons/lt_add_to_google_wallet_add-wallet-badge.png';

import {
  useUserDispatch,
  useUserState,
} from '@/components/context/UserContext';

export default function DiscountCards() {
  const userState = useUserState();
  const sessionDispatch = useUserDispatch();

  const [isGoogleDiscountCardPassLoading, setIsGoogleDiscountCardPassLoading] =
    useState(false);

  const [isAppleDiscountCardPassLoading, setIsAppleDiscountCardPassLoading] =
    useState(false);

  const { get: getAppleWalletPassDiscountCard } = useFetch(
    `/DigitalWallet/appleWalletpass`,
  );

  const { get: getAddDiscountCardToGoogleWalletUrl } = useFetch(
    `/DigitalWallet/googleWalletPass`,
  );

  const downloadFile = (data, filename) => {
    const blob = new Blob([data], { type: 'application/vnd.apple.pkpass' });
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }
  };

  const addApplePassToWallet = () => {
    setIsAppleDiscountCardPassLoading(true);
    getAppleWalletPassDiscountCard()
      .then((res) => {
        if (!!res.status && res.status !== 200) {
          setIsGoogleDiscountCardPassLoading(false);
          alert('Nepavyko atsisiųsti nuolaidų kortelės');
        } else {
          const binaryString = window.atob(res);
          const bytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          downloadFile(bytes, 'discount_card.pkpass');
          setIsAppleDiscountCardPassLoading(false);
        }
      })
      .catch(() => {
        alert('Nepavyko atsisiųsti nuolaidų kortelės');
      });
  };

  const addGooglePassToWallet = () => {
    setIsGoogleDiscountCardPassLoading(true);
    getAddDiscountCardToGoogleWalletUrl()
      .then((res) => {
        if (!!res.status && res.status !== 200) {
          setIsGoogleDiscountCardPassLoading(false);
          alert('Nepavyko atsisiųsti nuolaidų kortelės');
        } else {
          window.location.href = res;
        }
      })
      .catch(() => {
        setIsGoogleDiscountCardPassLoading(false);
        alert('Nepavyko atsisiųsti nuolaidų kortelės');
      });
  };

  if (!userState.cardNumber) return null;

  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <div className="flex flex-col gap-y-2">
        <Heading variant="userAccountTitle">
          Nuolaidų kortelė{' '}
          {!!userState.cardType && ' (' + userState.cardType + ')'}
        </Heading>
        <Label variant="subheading">
          Numeris: <span className="text-primary">{userState.cardNumber}</span>{' '}
          |{' '}
          {userState.cardValidTo ? (
            <>
              Galioja:{' '}
              <span className="text-primary">
                {moment(userState.cardValidFrom).format('YYYY-MM-DD')} -{' '}
                {moment(userState.cardValidTo).format('YYYY-MM-DD')}
              </span>
            </>
          ) : (
            <>
              Galioja nuo:{' '}
              <span className="text-primary">
                {moment(userState.cardValidFrom).format('YYYY-MM-DD')}
              </span>
            </>
          )}
        </Label>
      </div>

      <div className="flex flex-row items-center justify-center lg:justify-end gap-1">
        <img
          src={addToGoogleWallet}
          alt="Google Wallet"
          onClick={addGooglePassToWallet}
          className="w-40 h-10 object-contain cursor-pointer"
        />
        <img
          src={addToAppleWallet}
          alt="Apple Wallet"
          onClick={addApplePassToWallet}
          className="w-40 h-10 object-contain cursor-pointer"
        />
      </div>
    </div>
  );
}
